import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DEFAULT_COLUMN_SIZE, DEFAULT_MODE } from './Kanban.constants';
import { isEmpty } from 'lodash';
import * as S from './Kanban.styled';
import Text from '../../Atoms/Text/Text';
import Icon from '../../Atoms/Icon/Icon';
import { useCallback } from 'react';
import Tooltip from '../Tooltip/Tooltip';
import { Stack } from '../../Atoms/Stack';
// Component.
// -----------------------------------------------------------------------------
const Kanban = ({ content, mode = DEFAULT_MODE, columnSize = DEFAULT_COLUMN_SIZE, ...rest }) => {
    const renderTitle = useCallback((content, tooltip, label, icon) => {
        if ((label || icon) && tooltip) {
            return _jsx(Tooltip, { content: tooltip, children: content });
        }
        return content;
    }, []);
    // Guard condition.
    // -------------------------------------------------------------------------
    if (isEmpty(content)) {
        return null;
    }
    // Render.
    // -------------------------------------------------------------------------
    return (_jsx(S.KanbanRoot, { ...rest, children: content.map((cluster, index) => (_jsxs(S.KanbanCluster, { children: [_jsx(S.KanbanClusterTitle, { variant: cluster.variant || 'neutral', mode: mode, children: renderTitle(_jsxs(Stack, { gap: "xs", alignment: "center", children: [cluster.icon && _jsx(Icon, { icon: cluster.icon }), cluster.label && (_jsx(Text, { bold: true, size: "l", children: cluster.label }))] }), cluster.tooltip, cluster.label, cluster.icon) }), _jsx(S.KanbanClusterContent, { variant: cluster.variant || 'neutral', mode: mode, children: cluster.columns.map((column, index) => (_jsx(S.KanbanColumn, { children: _jsx(S.KanbanColumnContent, { columnSize: columnSize, children: column.tiles.map((column, index) => (_jsxs(S.KanbanTile, { children: [_jsx(S.KanbanTileTitle, { children: renderTitle(_jsxs(Stack, { gap: "xs", alignment: "flex-start", children: [column.icon && _jsx(Icon, { icon: column.icon }), column.label && _jsx(Text, { bold: true, children: column.label })] }), column.tooltip, column.label, column.icon) }), _jsx(S.KanbanTileContent, { children: column.renderCards((content) => (_jsx(S.KanbanCard, { mode: mode, children: content }))) })] }, index))) }) }, index))) })] }, index))) }));
};
// Component configuration.
// -----------------------------------------------------------------------------
Kanban.displayName = 'Kanban';
export default Kanban;
//# sourceMappingURL=Kanban.js.map